export const userProfileTranslations = {
  menu_text: 8212,
  notifications_text: 8213,
  settings_text: 8214,
  default_values_text: 8215,
  subscriptions: 8781,
  no_content: 8239,
  subscriptions_section_title: 8779,
  subscriptions_section_disclaimer: 8780,
  subscribed_text: 8808,
  no_subscriptions: 8819,
  main_title: 8221
};

export type UserProfileTranslation = {
  readonly [T in keyof typeof userProfileTranslations]: string
};
